export { default } from './WifiDevice.jsx';
